enum Modes {
    User = 'user',
    Operator = 'operator',
}

export default Modes;
